import { render, staticRenderFns } from "./HospitalList.vue?vue&type=template&id=32ae9ce8&scoped=true"
import script from "./HospitalList.vue?vue&type=script&lang=js"
export * from "./HospitalList.vue?vue&type=script&lang=js"
import style0 from "./HospitalList.vue?vue&type=style&index=0&id=32ae9ce8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ae9ce8",
  null
  
)

export default component.exports